import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { ButtonToolbar, Dropdown, DropdownButton } from 'react-bootstrap';

import { moveGraph, addGraphByPosition, removeGraph } from '@stores/graphViewPageSlice';

const GraphActions = ({ graphId }) => {
  const dispatch = useDispatch();

  function handleSelect(value) {
    const payload = {
      graphId: graphId.slice(0, graphId.lastIndexOf('_')),
      viewAction: value,
    };

    if (value == 'up' || value == 'down') {
      dispatch(moveGraph(payload));
    }
    if (value == 'remove') {
      dispatch(removeGraph(payload));
    }
    if (value == 'addAbove' || value == 'addBelow') {
      dispatch(addGraphByPosition(payload));
    }
  }

  return (
    <div className="graph__actions">
      <ButtonToolbar>
        <DropdownButton id="graph-actions" title="Actions" onSelect={handleSelect}>
          <Dropdown.Item eventKey="up">Move Up</Dropdown.Item>
          <Dropdown.Item eventKey="down">Move Down</Dropdown.Item>
          <Dropdown.Item eventKey="addAbove">Add Graph Above</Dropdown.Item>
          <Dropdown.Item eventKey="addBelow">Add Graph Below</Dropdown.Item>
          <Dropdown.Item eventKey="remove">Remove Graph</Dropdown.Item>
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
};

GraphActions.propTypes = {
  graphId: PropTypes.any.isRequired,
};

export default GraphActions;
